import getBrightness from './getBrightness';
import getRGB from './getRGB';

export function isLightTheme(color) {
  const rgb = getRGB(color);
  return getBrightness(rgb) > 191;
}

export default function setContrastColorBasedOnBackground(color) {
  if (isLightTheme(color)) return '#000';
  return '#fff';
}
